import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.WhatInBox');

    const listA = [
        {
            title: t('a_tab'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724234229943/a1.png',
        },
        {
            title: t('b_tab'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724319841216/a2.png',
        },
        // {
        //     title: t('c_tab'),
        //     pc: 'https://websiteoss.ecoflow.com/upload/image/1724319771019/a3.png',
        // },
        {
            title: t('d_tab'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724392591277/a4.png',
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfTitle hasAnimation={false}>{t('title')}</EfTitle>
            <ul className="items">
                {listA.map((item, k) => (
                    <li key={item.title} className={`item item-${k + 1}`} style={{ gridArea: `item-${k + 1}` }}>
                        <img className="item-img" src={item.pc} alt={item.title} loading="lazy" width={'100%'} height="100%" />
                        <p className="item-title">{item.title}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}
